import { RetailerService } from '../api/retailer.service';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { IOperationFilter, IOperationStatistic, IOperationStatisticPagingResult, IOperationStatisticsDetailed, IImportResult, OperationMessageKind, OperationMessageSource, IOperationStatisticModel, IOperationStatisticModelPagingResult, IOperationStatisticDetailedModel } from './models';
import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'underscore';

export class OperationService {
    static $inject = ['http', 'retailerService', '$translate'];

    private readonly sourceNames = {
        [OperationMessageSource.API]: 'API',
        [OperationMessageSource.CSV]: 'CSV'
    };

    private readonly operationKindNames = {
        [OperationMessageKind.FullUpdate]: this.$translate.instant('full_update'),
        [OperationMessageKind.PriceUpdate]: this.$translate.instant('price_update'),
        [OperationMessageKind.VariationArchive]: this.$translate.instant('archive_variants'),
        [OperationMessageKind.FullUpdateReplace]: this.$translate.instant('update_and_replace'),
        [OperationMessageKind.StockQuantityUpdate]: this.$translate.instant('stock_quantity_update'),
        [OperationMessageKind.ProductsImportBySku]: this.$translate.instant('import_by_sku')
    };

    constructor(
        private http: HttpService,
        private retailerService: RetailerService,
        private readonly $translate: angular.translate.ITranslateService
    ) {

    }

    getOperation(id: string): ng.IPromise<IOperationStatisticDetailedModel> {
        return this.http
            .get<IOperationStatisticsDetailed>(this.retailerService.getOperationUrl(id))
            .then((response) => {
                let result = <IOperationStatisticDetailedModel>this.mapOperationStatistics(response);
                result.Errors = response.Errors;
                return result;
            });
    }

    getOperationList(filter: IOperationFilter): ng.IPromise<IOperationStatisticModelPagingResult> {
        return this.http
            .get<IOperationStatisticPagingResult>(this.retailerService.getOperationListUrl(), { params: filter })
            .then(response => this.mapOperationStatisticsPagingResult(response));
    }

    importFile(file: File, replace: boolean): ng.IPromise<IImportResult> {
        let form = new FormData();
        form.append('file', file, file.name);

        return this.http.post<IImportResult>(this.retailerService.getImportFileUrl(replace), form, {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        })
        .then(response => {
            if (response.Success && response.Operation) {
                response.OperationModel = this.mapOperationStatistics(response.Operation);
            }

            return response;
        });
    }

    private mapOperationStatisticsPagingResult(source: IOperationStatisticPagingResult): IOperationStatisticModelPagingResult {
        return {
            Total: source.Total,
            Items: _.map(source.Items, (value) => this.mapOperationStatistics(value))
        };
    }

    private mapOperationStatistics(source: IOperationStatistic): IOperationStatisticModel {
        let start = moment(source.RequestTimeStamp);
        let duration = moment.duration(source.Duration).asMilliseconds();
        let end = duration ? moment(start).add(duration, 'ms').toDate() : null;

        return {
            ID: source.ID,
            RetailerID: source.RetailerID,
            ClientID: source.ClientID,
            RequestTimeStamp: start.toDate(),
            FinishedAt: end,

            Source: this.sourceNames[source.Source],
            Kind: this.operationKindNames[source.Kind],
            Status: source.Status,
            Result: source.Result,

            ItemsCount: source.ItemsCount,
            ItemsUpdatedCount: source.ItemsUpdatedCount,
            ItemsAddedCount: source.ItemsAddedCount,

            ErrorsCount: source.ErrorsCount,
            ConflictsCount: source.ConflictsCount
        };
    }
}

angular
    .module('naut')
    .service('operationService', OperationService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/operation.service.ts